module.exports = __webpack_public_path__ + "img/admin.e93a330c.png";